import { Component } from '@angular/core';
import { config } from '@fortawesome/fontawesome-svg-core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { SwUpdateService } from './service/sw-update.service';
config.autoAddCss = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  showModalFestive = true;
  closeModal() {
    this.showModalFestive = false;
  }
  isTemplateVisible: boolean = true;
  isFloatingBtnVisible: boolean = true;
  isHome: boolean = false;
  isShowed: boolean = false;
  isAdmin: boolean = false;
  isPageSale: boolean = false;
  constructor(
    private router: Router,
    private swUpdateService: SwUpdateService,
  ) {
    this.swUpdateService.init();
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.logRedirection(event.urlAfterRedirects, event.url);
      });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isTemplateVisible =
          !this.router.url.includes('error') &&
          !this.router.url.includes('admin');
        this.isShowed =
          this.router.url.includes('/blog') ||
          this.router.url.includes('/articles') ||
          this.router.url.includes('/categories') ||
          this.router.url.includes('/all-articles');
        this.isAdmin = this.router.url.includes('/admin');
        this.isPageSale =
          this.router.url.includes('/blackfriday') ||
          this.router.url.includes('/festive-sale') ||
          this.router.url.includes('/september-peak-sale') ||
          this.router.url.includes('/winter-sale') ||
          this.router.url.includes('/touring/');
        this.isFloatingBtnVisible = !this.router.url.includes('blog');
      });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isHome = this.router.url === '/';
      });
  }

  private logRedirection(redirectedUrl: string, originalUrl: string) {}
}
